import { SVGInterface } from "../../interface";

const Tennis = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M19.5999 2.48898C17.2599 0.148981 12.9799 0.618981 10.0499 3.54898C8.44992 5.14898 7.52992 7.41898 7.50992 9.00898C7.48992 10.589 7.76992 12.899 6.15992 14.509L1.91992 18.749L3.33992 20.169L7.57992 15.929C9.18992 14.319 11.4999 14.599 13.0799 14.579C14.6599 14.559 16.9399 13.639 18.5399 12.039C21.4599 9.10898 21.9399 4.82898 19.5999 2.48898ZM10.3999 11.679C8.86992 10.149 9.34992 7.06898 11.4599 4.95898C13.5699 2.84898 16.6399 2.36898 18.1799 3.89898C19.7099 5.42898 19.2299 8.50898 17.1199 10.619C15.0099 12.729 11.9399 13.209 10.3999 11.679Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M18.0799 16.999C18.6099 16.999 19.1199 17.209 19.4899 17.589C20.2699 18.369 20.2699 19.639 19.4899 20.419C19.1199 20.789 18.6099 20.999 18.0799 20.999C17.5499 20.999 17.0399 20.789 16.6699 20.409C15.8899 19.629 15.8899 18.359 16.6699 17.579C17.0399 17.209 17.5499 16.999 18.0799 16.999ZM18.0799 14.999C17.0599 14.999 16.0299 15.389 15.2499 16.169C13.6899 17.729 13.6899 20.259 15.2499 21.829C16.0299 22.609 17.0599 22.999 18.0799 22.999C19.0999 22.999 20.1299 22.609 20.9099 21.829C22.4699 20.269 22.4699 17.739 20.9099 16.169C20.1299 15.389 19.0999 14.999 18.0799 14.999Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Tennis;
